import Papa from 'papaparse';

const safeExportValue = (value) => {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const exportVisibleCsv = async ({ table, onEmpty, onSuccess, onError }) => {
  const exportableColumns = (table.getAllLeafColumns?.() || []).filter((col) => {
    const id = col?.id;
    if (!id) return false;
    if (id === 'mrt-row-select') return false;
    if (!col.getIsVisible?.()) return false;
    return Boolean(col.columnDef?.header);
  });
  const exportRows = table.getFilteredRowModel?.().rows?.map((r) => r.original) || [];
  if (!exportRows.length) {
    onEmpty?.();
    return;
  }
  const columnsToExport = exportableColumns.map((c) => c.id);
  const sanitized = exportRows.map((row) => {
    const out = {};
    exportableColumns.forEach((col) => {
      const accessor = col.columnDef?.accessorFn;
      const key = col.columnDef?.accessorKey;
      let value = '';
      if (typeof accessor === 'function') value = accessor(row);
      else if (key) value = row[key];
      else value = row[col.id];
      out[col.id] = safeExportValue(value);
    });
    return out;
  });
  const csv = Papa.unparse(sanitized, { quotes: true, columns: columnsToExport });
  const fileName = `appsheet_orderitems_${new Date().toISOString().split('T')[0]}.csv`;
  try {
    const { saveCsvFile } = await import('../../../utils/fileSystemAccess');
    const result = await saveCsvFile(csv, fileName);
    if (result.success && !result.cancelled) {
      onSuccess?.(exportRows.length);
      return;
    }
    if (result.cancelled) return;
  } catch (error) {
    onError?.(error);
  }
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  onSuccess?.(exportRows.length);
};
